"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var defaults = {
  firstName: '',
  lastName: '',
  email: '',
  fullName: '',
  name: '',
  userId: null
};

var UserProfile = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(UserProfile, _Record);

  function UserProfile() {
    (0, _classCallCheck2.default)(this, UserProfile);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UserProfile).apply(this, arguments));
  }

  (0, _createClass2.default)(UserProfile, null, [{
    key: "from",
    value: function from(json) {
      return new UserProfile(json);
    }
  }, {
    key: "fromUser",
    value: function fromUser(json) {
      return new UserProfile(Object.assign({
        firstName: json.first_name,
        lastName: json.last_name,
        userId: json.user_id
      }, json));
    }
  }]);
  return UserProfile;
}((0, _immutable.Record)(defaults));

exports.default = UserProfile;
module.exports = exports.default;